import { lazy, Suspense } from "react";
import Footer from "@/components/Footer";
import HeroSection from "@/components/HeroSection";
import Navigation from "@/components/Navigation";

// Below-the-fold sections (and their forms/carousel) load after the hero renders
const AdvertisingSection = lazy(() => import("@/components/AdvertisingSection"));
const ServicesSection = lazy(() => import("@/components/ServicesSection"));

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <main>
        <HeroSection />
        <Suspense fallback={null}>
          <AdvertisingSection />
          <ServicesSection />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
};

export default Index;
